/*
 * @Author: Merlin
 * @Date: 2023-12-28 14:36:49
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-26 11:23:08
 * @Description: 有关游戏的公共方法
 */

// 👇取得游戏名称
export function getGameName(
    path = '',
) {
    path ||= useRoute().path;
    // ↓ 正则说明：以 game 结尾才是游戏名，
    const theReExp = /\/casino\/[a-z]+game/i;
    let [sGameName = ''] = path.match(theReExp) || [];
    // ↓ 删除 /casino/ 前缀
    sGameName &&= sGameName.slice(8);
    return sGameName;
}

// 👇 通过地址取得游戏信息 
export function getGameInfo(
    path = '',
) {
    let sGameName = getGameName(path) || '';
    const isGameWithEntrance = aGameWithEntrance.includes(sGameName);
    const isGameWithHistoryTable = !aNoTableGames.includes(sGameName);
    // ↓ 最终结果 
    const oResult = {
        gameName: sGameName,
        gameNameShort: sGameName.slice(0, -4), // 删除尾部的 'Game' 
        gameNameStrict: '', // 只有 strictGamePage == true 才会为此赋值 
        gameApi: sGameName ? getGameApi(sGameName) : '',
        isGameWithHistoryTable,
        // ↓ 表示是否彻底进入了游戏页 
        // ↓ 在传统游戏时：只要取得游戏名，即视为在游戏页；
        // ↓ 在特殊游戏时：仅在到达 /index/id 时才算进入游戏页（将在下方赋值）
        strictGamePage: !isGameWithEntrance, // 非特殊游戏则在此赋值为 true, 否则在下方赋值  
        // -- ↑ 通用部分 ------------------------------------ 
        // -- ↓ 有入口页的几个特殊游戏专用 
        isGameWithEntrance,
        indoorPage: false, // 按需在下方赋值 
        entrancePage: false, // 按需在下方赋值 
        indoorOrEntrance: false, // 按需在下方赋值 
    }
    // ↓ 特殊游戏专用
    if (isGameWithEntrance) {
        const indoorPage = path.match(/\/\w+game\/indoor\/\d+/i);
        const entrancePage = path.match(/\/\w+game\/entrance\b/i);
        Object.assign(oResult, {
            strictGamePage: !!indoorPage,
            indoorPage: !!indoorPage,
            entrancePage: !!entrancePage,
            indoorOrEntrance: !!(indoorPage || entrancePage),
        });
    }
    if (oResult.strictGamePage){
        oResult.gameNameStrict = oResult.gameName;
    }
    return oResult;
}

// 👇 游戏名与 api 名对照表
export const oGameName2Api = {
    // 游戏名在地址栏中的名：'游戏接口名',
    crashGame: 'crash',
    plinkoGame: 'plinko',
    spacediceGame: 'spacedice',
    diceGame: 'dice',
    coinflipGame: 'coinflip',
    limboGame: 'limbo',
    ringGame: 'ring',
    cryptosGame: 'cryptos',
    tripleGame: 'triple',
    kenoGame: 'keno',
    hiloGame: 'hilo',
    rouletteGame: 'roulette',
    circleGame: 'circle',
    stairsGame: 'stairs',
    minesGame: 'mines',
    towerGame: 'tower',
    blackjackGame: 'blackjack',
    redpacketGame: 'redpacket',
    niuniuGame: 'niuniu',
    zhajinhuaGame: 'zhajinhua',
    jisuzhajinhuaGame: 'jisuzhajinhua',
    // ↓ corgi●●● 系列 ------------------------
    corgipharaohGame: 'corgipharaoh',
    corgiwildGame: 'corgiwild',
    futuresGame: 'futures',
};

// ↓ 游戏名：记录此游戏“进行中的游戏数据” 的属性名  
const oGameName2LastRoundKey = {
    crashGame: 'bets',
    corgipharaohGame: 'activeBonusGame',
    // ↑ 其它
    // ↓ lastRound
    blackjackGame: 'lastRound',
    hiloGame: 'lastRound',
    minesGame: 'lastRound',
    towerGame: 'lastRound',
    coinflipGame: 'lastRound',
    stairsGame: 'lastRound',
};

// 这些游戏没有下方的历史表格，所以不应调用传统的历史数据接口，否则报错 
export const aNoTableGames = [ 
    'niuniuGame',
    'redpacketGame',
    'zhajinhuaGame',
    'jisuzhajinhuaGame',
];

// 这些游戏是特殊游戏，它们需要首先到达【入口页】，选择某厅后才能真正进入游戏 
export const aGameWithEntrance = [
    'niuniuGame',
    'redpacketGame',
    'zhajinhuaGame',
    'jisuzhajinhuaGame',
];

// 下列这些游戏在进行途中如果退出了，再次进入游戏时“不会” 加载残局 
// 相反地：hilo, mines 这些游戏“会” 加载残局 
export const aGamesLosingStatus = [
    'crashGame', // 有可能按情况加载残局，也有可能不加载
    'redpacketGame',
    'niuniuGame',
    'zhajinhuaGame',
    'jisuzhajinhuaGame',
];

// 以下游戏没有 hash 码 
export const aGamesWithoutHash = [
    'futures',
    'niuniu',
    'redpacket',
    'zhajinhua',
    'jisuzhajinhua',
];


// ↓ 需要延时插入游戏结果的游戏列表
// ↓ 在此陈列的游戏不应“立即” 在游戏下方的大表格显示游戏结果，
// ↓ 应在游戏动画播放完毕后，再经由"特定方法" 的调用显示游戏结果，
// ↓ 特定方法即: oJoinStateStore.showDateInQueue();
export const aGamesShowResultWithDelay = [
    'plinkoGame', 'limboGame', 'coinflipGame',
    'kenoGame', 'rouletteGame', 'corgipharaohGame',
    'corgiwildGame', 'tripleGame', 'circleGame',
    'spacediceGame', 'cryptosGame', 'diceGame',
    'ringGame', 'stairsGame',
    // 'towerGame' // 已关闭，不必延时（实测游戏结束后才会收到大表格的行数据）此项应取消 
];


// 👇取得游戏 api （默认依据 url 取得 api）
export function getGameApi(sGameName = '') {
    sGameName ||= getGameName();
    // ↓ 不在游戏页固然无法取得 api 
    if (!sGameName) return '';
    const sApi = oGameName2Api[sGameName] || '';
    if (!sApi && import.meta.dev) {
        console.warn('注意，查询游戏 api 名称失败');
    }
    return sApi;
}


// 👇 取得游戏的数据属性名 
export function getGameLastRoundKey(sGameName = '') {
    sGameName ||= getGameName();
    // ↓ 不在游戏页则返回
    if (!sGameName) return '';
    const sTheKey = oGameName2LastRoundKey[sGameName] || '';
    return sTheKey;
}

